/*
 * Structural-only sx contributions for the materialUI Card wrapper.
 *
 * Colors, radius, and shadows now come from the MUI theme + tokens.css
 * via var(--shadow-sm, ...) so the design-system refresh does not require
 * re-editing this file. Gradient variants are dropped per the Jyrney spec
 * (cards are white surfaces with a navy-tinted shadow — never gradient).
 */

const cardStyle = {
  card: {
    border: '0',
    marginBottom: 'var(--sp-8, 32px)',
    marginTop: 'var(--sp-8, 32px)',
    borderRadius: 'var(--r-lg, 14px)',
    color: 'var(--color-text, #0d1418)',
    background: 'var(--color-surface, #fff)',
    width: '100%',
    boxShadow: 'var(--shadow-sm, 0 2px 6px rgba(10, 37, 61, 0.08))',
    position: 'relative',
    display: 'flex',
    flexDirection: 'column',
    minWidth: '0',
    wordWrap: 'break-word',
    fontSize: '.875rem',
  },
  cardPlain: {
    background: 'transparent',
    boxShadow: 'none',
  },
  cardProfile: { marginTop: 'var(--sp-8, 32px)', textAlign: 'center' },
  cardBlog: { marginTop: 'var(--sp-16, 64px)' },
  cardRaised: {
    boxShadow: 'var(--shadow-md, 0 6px 18px rgba(10, 37, 61, 0.10))',
  },
  cardBackground: {
    backgroundPosition: 'center center',
    backgroundSize: 'cover',
    textAlign: 'center',
    '&:after': {
      position: 'absolute',
      zIndex: '1',
      width: '100%',
      height: '100%',
      display: 'block',
      left: '0',
      top: '0',
      content: '""',
      backgroundColor: 'rgba(0, 37, 61, 0.56)',
      borderRadius: 'var(--r-lg, 14px)',
    },
    '& small': { color: 'rgba(255, 255, 255, 0.85) !important' },
  },
  cardPricing: {
    textAlign: 'center',
    '& ul': {
      listStyle: 'none',
      padding: 0,
      maxWidth: '240px',
      margin: '10px auto',
    },
    '& ul li': {
      color: 'var(--color-text, #0d1418)',
      textAlign: 'center',
      padding: '12px 0px',
      borderBottom: '1px solid var(--color-border, #e2e6ea)',
    },
    '& ul li:last-child': { border: 0 },
    '& h1': { marginTop: '30px' },
    '& h1 small': { display: 'inline-flex', height: 0, fontSize: '18px' },
    '& h1 small:first-child': {
      position: 'relative',
      top: '-17px',
      fontSize: '26px',
    },
  },
  cardPricingColor: {
    '& ul li': {
      color: '#fff',
      borderColor: 'rgba(255, 255, 255, 0.3)',
      '& b, & svg,& .fab,& .fas,& .far,& .fal,& .material-icons': {
        color: '#fff',
        fontWeight: '700',
      },
    },
  },
  cardProduct: { marginTop: '30px' },

  // Color variants — flat accent backgrounds, no gradients.
  primary: { background: 'var(--jy-navy-900, #00253d)', color: '#fff' },
  info: { background: 'var(--jy-info, #155b95)', color: '#fff' },
  success: { background: 'var(--jy-success, #167a4e)', color: '#fff' },
  warning: { background: 'var(--jy-warning, #9a5f14)', color: '#fff' },
  danger: { background: 'var(--jy-danger, #b23125)', color: '#fff' },
  rose: (theme) => ({
    background: theme.palette.rose?.['200'] || '#E91E63',
    color: '#fff',
  }),

  cardChart: { '& p': { marginTop: '0px', paddingTop: '0px' } },
  cardLogin: { transition: 'all 300ms linear' },
}

export default cardStyle
